<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Sub Category Preview"
      id="admin_edit_sub_category_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
      <v-btn
        :to="
          '/admin/categories/sub_categories/view/' +
          $route.params.id +
          '/delete'
        "
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-trash-can</v-icon> Remove Sub Category
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="sub_category.name"
        :icon="sub_category.icon"
        :img_src="sub_category.thumb_nail"
        :facts="view_header_facts"
        :description="sub_category.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Edit Sub Category Form"
      id="admin_edit_sub_category_form"
    ></CardedSectionHeader>
    <AdminCategoriesAddSubCategory
      @on-show-loader="show_loader"
      @on-hide-loader="hide_loader"
      :is_editing="true"
      :is_loading="is_loading"
      ref="add_sub_category_form_comp_ref"
      @on-success-edit="on_success_edit"
    >
    </AdminCategoriesAddSubCategory>
  </div>
</template>
<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import ViewHeader from "../../../components/ViewHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import AdminCategoriesAddSubCategory from "./AdminCategoriesAddSubCategory";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminSubCategoriesEdit",
  components: {
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    AdminCategoriesAddSubCategory,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      sub_category: {
        id: 0,
        name: "",
        category: null,
        thumb_nail: "",
        description: "",
      },
    };
  },
  methods: {
    show_loader() {
      this.$emit("on-show-loader");
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    load_sub_category(){
      ServerClient.Categories.get_sub_category(
      {
        id: this.$route.params.id,
        is_edit: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.sub_category = res;
        this.$refs.add_sub_category_form_comp_ref.fill_edit_category(res);
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log(
          "Errors while loading sub category details on admin",
          errors
        );
      }
    );
    },
    on_success_edit(){
      this.load_sub_category();
    }
  },

  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Category:",
          val: this.sub_category.category
            ? this.sub_category.category.name
            : "",
        },
        {
          text: "Top Category:",
          val:
            this.sub_category.category &&
            parseInt(this.sub_category.category.is_top_category) == 1
              ? "Yes"
              : "No",
        },
        {
          text: "Top Category Level:",
          val: this.sub_category.category
            ? this.sub_category.category.top_category_level
            : 0,
        },
      ];
      return facts;
    },
  },

  mounted() {
    var sub_category_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Edit Sub Category",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "Subs",
          disabled: false,
          href: "/admin/categories/sub_categories/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/categories/sub_categories/view/" + sub_category_id,
        },
        {
          text: "Edit",
          disabled: true,
          href:"/admin/categories/sub_categories/view/"+sub_category_id+"/edit" 
        }
      ],
      navbar_cols: 3
    });
    this.load_sub_category();
  },
};
</script>

